<template style="overflow: hidden;">
  <div id="login">
    <v-flex xl3 lg4 offset-lg4 md5 offset-md4 sm6 xs12 class="login_content mx-auto px-auto">
      <v-card class="elevation-24" style="opacity:0.95;border-radius:10px;">
        <v-form
          lazy-validation
          class="form-horizontal py-2 px-5"
          style="background: #FFF; margin-top: 150px;"
        >
          <div align="center" class="py-2">
            <h4 style="font-size: 21px; font-family: Muli, Helvetica, Arial, sans-serif; font-weight: 600;">Login Form</h4>
          </div>

          <v-progress-linear
            :indeterminate="processBar"
            class="my-0"
            :height="height"
            :background-opacity="opacity"></v-progress-linear>

          <v-flex>
            <v-text-field
              v-model="login.email"
              id="email"
              type="email"
              label="Email"
              placeholder="Username/Email"
              required
              :rules="[v => !!v || 'email or username required']"
              autofocus
              prepend-inner-icon="person"
            ></v-text-field>
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="login.password"
              :error-messages="errors"
              id="password"
              :rules="[v => !!v || 'password is required']"
              type="password"
              label="Password"
              v-on:keyup.enter="validateCaptcha && loginUser()"
              placeholder="************"
              required
              prepend-inner-icon="lock"
            ></v-text-field>
          </v-flex>
          <div>
            <vue-recaptcha
              sitekey="6LcJ9dEcAAAAAOfDDMMxdfwx0gFaYs6vjhyfts-v"
              :loadRecaptchaScript="true"
              ref="recaptcha"
              @verify="onCaptchaVerified"
              @expired="onCaptchaExpired"
            ></vue-recaptcha>
            <v-btn
              block
              color="#4caf50 !important"
              class="btn btn-default white--text"
              id="submit_btn"
              primary
              :disabled="login_btn_status || !validateCaptcha"
              @click="loginUser()"
            ><b>Login</b></v-btn>
          </div>
          <br />
          <div class="py-2">
            
            <div class="text-center">
              <v-dialog v-model="dialog" width="500">
                <template v-slot:activator="{ on }">
                  <a class v-on="on" style="cursor: pointer; color: #3091B2; text-decoration: none;">Lost your password?</a>
                  <br/>
                </template>

                <v-card>
                  <v-card-title class="subheading grey lighten-2" primary-title>Reset Password</v-card-title>
                  <v-flex>
                    <v-text-field
                      class="px-3"
                      id="email"
                      type="email"
                      label="Email"
                      placeholder="please enter your email to reset your password"
                      required
                      prepend-inner-icon="person"
                    ></v-text-field>
                  </v-flex>
                  <div id="errorContent"></div>
                  <br/>
                  <v-divider></v-divider>

                  <v-card-actions>
                    <v-btn color="#1976d2 !important" class="btn btn-default white--text" text>Cancel</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="#1976d2 !important" class="btn btn-default white--text" text id="btn_send_email">Send Me Email</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
            
        <font face="Arial, Helvetica, sans-serif" size="2" color="#4db3a4">
				<strong style="font-family: Arial, Helvetica, sans-serif; color: #4db3a4;">
				<a href="#1" target="_blank" style="color: #4db3a4; text-decoration: none;">Customer support</a>
				</strong></font>
				<br>
				<font face="Arial, Helvetica, sans-serif" size="2" color="#96a5b5">
				<span style="font-family: Arial, Helvetica, sans-serif; color: #96a5b5;">
					
					Phone: 844-843-3170 <br> Email: isosupport@advantagecapitalfunding.com
					
				</span></font>		
            
            
          </div>

          <div class="clearfix"></div>

        </v-form>
      </v-card>
    </v-flex>

    <v-dialog v-model="tenantDialog" persistent width="420">
      <v-card>
        <v-card-title class="subheading grey lighten-2" primary-title>Select Company</v-card-title>
        <v-list two-line>
          <v-list-tile v-for="tenant in tenants" :key="tenant.id" @click="selectTenant(tenant)">
            <v-list-tile-content>
              <v-list-tile-title>{{ tenant.name }}</v-list-tile-title>
              <v-list-tile-sub-title v-if="tenant.domain">{{ tenant.domain.domain }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="grey" @click="tenantDialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from 'axios';
import {URL} from '../../env'
import {config} from '../../config'
import moment from 'moment'
import { EventBus } from '../main.js';
import UserLoginHelper from '../helpers/user_login_helper'
import VueRecaptcha from 'vue-recaptcha'
export default {
  mixins: [UserLoginHelper],
  components: { 'vue-recaptcha' : VueRecaptcha },
  data() {
    return {
      ip: null,
      login_btn_status: false,
      tiktik: null,
      date: moment(60 * 10 * 1000),
      errors: [],
      dialog: false,
      opacity: 0,
      height: 4,
      processBar: false,
      login: {
        email: '',
        password: '',
        recaptcha: '',
      },
      loadingPage: true,
      setinterval: null,
      validateCaptcha: false,
      tenants: [],
      tenantDialog: false
    };
  },
  computed: {
    time(){
      return this.date.format('mm:ss');
    }
  },
  mounted(){
    this.checkLoginAttemptIfExists()
    this.logoutEventBusListener()
    this.onCaptchaExpired()
    this.loadingPage = false
  },
  watch: {
    time(){
      this.$nextTick(()=>{
        if(moment(this.date).format('mm') == 10 && moment(this.date).format('ss') == 0){
          this.errors = []
        }else{
          this.errors = []
          this.errors[0] = 'Too many login attempts. Please try again after ' + this.time +  ' sec'
        }
      })
    }
  },
  methods: {
    onCaptchaVerified: function (recaptchaToken) {
      this.login.recaptcha = recaptchaToken
      this.validateCaptcha = true
    },
    onCaptchaExpired: function () {
      this.$refs.recaptcha.reset();
      this.validateCaptcha = false;
      this.login.recaptcha = '';
    },
    logoutEventBusListener(){
      EventBus.$on("logoutEvent", (status) => {
        this.autoLogOutFunction()
      });
    },
    checkLoginAttemptIfExists(){
      if(localStorage.getItem('startTime') !== null && localStorage.getItem('login_attempts') > 3)
      {
        let locked_email = localStorage.getItem('email_locked')
        if(locked_email != null)
        {
          let locked_user = null
          axios.get(`/user/user_locked/` + locked_email).then(res=>{
            if(res.data.length>0 && res.data[0].login_attempts_status == 0){
              locked_user = res.data[0]
              this.stopLoginAttemptInterval()
            }
          }).catch(() => {})
          if(locked_user && locked_user.login_attempts_status == 0)
            return;
        }
        let then = moment(localStorage.getItem('startTime'));
        let now = moment();
        let sec = moment.duration(now.diff(then)).asSeconds();
        let intervalTime = moment(60 * 10 * 1000)
        this.date = moment(intervalTime.subtract(parseInt(sec), 'seconds'))
        this.login_btn_status = true
        this.startLoginAttemptTimer()
      }
    },
    startLoginAttemptTimer(){
      this.tiktik = setInterval(() => {
        this.date = moment(this.date.subtract(1, 'seconds'))
        if(moment(this.date).format('mm') == 0 && moment(this.date).format('ss') < 1){
          this.date = moment(60 * 10 * 1000)
          this.stopLoginAttemptInterval()
        }
      }, 1000);
    },
    stopLoginAttemptInterval(){
      this.errors = []
      this.login_btn_status = false
      localStorage.removeItem('email_locked');
      localStorage.removeItem('login_attempts')
      localStorage.removeItem('startTime')
      this.lockUnlockUser(0)
      clearInterval(this.tiktik);
    },
    autoLogOutFunction(){
      this.initialTimestamp();
      this.timeChecker();
    },
    initialTimestamp() {
      var timeStamp = new Date();
      localStorage.setItem("lastTimeStamp", timeStamp);
    },
    timeChecker() {
      let app = this;
      this.setinterval = setInterval(function() {
        var storedTimeStamp = localStorage.getItem("lastTimeStamp");
        app.timeCompare(storedTimeStamp);
      }, 3000);
    },
    timeCompare(timeString) {
      let app = this;
      var maxMinutes = 0.5 * 15 // * 2; // means (1min * 60 * 2) = 2 hours //GREATER THEN 1440 MIN OR 24 HOURS.
      var currentTime = new Date();
      var pastTime = new Date(timeString);
      var timeDiff = currentTime - pastTime;
      var minPast = Math.floor(timeDiff / 60000);
      if (timeString) {
        if (minPast >= maxMinutes) {
          EventBus.$emit('logOffDialog', 'open_dialog');
          clearInterval(this.setinterval)
        } else {
        }
      }
    },
    lockUnlockUser(status){
      axios.post(`/user/user_locked`, {
        email: localStorage.getItem('email_locked'),
        login_attempts_status: status
      }).catch(() => {})
    },
    async loginUser() {
      let app = this
      this.errors = []
      app.processBar = true
      let tenantResponse = null
      try {
        tenantResponse = await axios.post(`${URL}/api/non-tenant/log-in`, {
          username: this.login.email,
          password: this.login.password,
        });
      } catch (err) {
        this.errors.push('The user credentials were incorrect');
        app.processBar = false
        return
      }
      const tenants = tenantResponse.data
      if (!Array.isArray(tenants) || tenants.length == 0) {
        this.errors.push((tenants && tenants.message) ? tenants.message : 'The user credentials were incorrect');
        app.processBar = false
        return
      }
      if (tenants.length == 1) {
        sessionStorage.setItem("X-TENANT", tenants[0].id);
        await this.completeLogin()
        return
      }
      this.tenants = tenants
      this.tenantDialog = true
      app.processBar = false
    },
    async selectTenant(tenant) {
      this.tenantDialog = false
      sessionStorage.setItem("X-TENANT", tenant.id);
      this.processBar = true
      await this.completeLogin()
    },
    async completeLogin() {
      let app = this
      let _payload = {
        username: this.login.email,
        password: this.login.password,
        grant_type: "password",
        client_id: config.clientId,
        client_secret: config.clientSecret,
        scope: ""
      };

      let response_auth = await axios.post(`${URL}/api/non-tenant/oauth/token`, _payload).catch(err => {
        if (err == 'Error: Request failed with status code 401') {
          let login_attempts = (localStorage.getItem('login_attempts') != null) ? parseInt(localStorage.getItem('login_attempts')) + 1 : 1
          localStorage.setItem('login_attempts', login_attempts)
          if (localStorage.getItem('startTime') == null && login_attempts > 3) {
            let startTime = moment();
            localStorage.setItem('startTime', startTime);
            this.login_btn_status = true
            this.startLoginAttemptTimer()
            this.errors.push('Too many login attempts. Please try again after ' + this.time + ' sec');
            // save login attempt status in users table
            localStorage.setItem('email_locked', this.login.email);
            this.lockUnlockUser(1)
            // end
          } else {
            this.errors.push('The user credentials were incorrect');
          }
        } else {
          this.errors.push('The user credentials were incorrect');
        }
        app.processBar = false
      })

      if (!response_auth || !response_auth.data || !response_auth.data.access_token) {
        app.processBar = false
        return
      }

      localStorage.setItem('access_token', response_auth.data.access_token)

      await axios.post(`${URL}/api/iso_auth/${this.login.email}`, this.login).catch(err=>{
        localStorage.removeItem('access_token')
        this.errors.push('The user credentials were incorrect');
      }).then(response => {
        if (!response || !response.data || !response.data.data) {
          return
        }
        if(response.data.data.terminated_user == 1){
          return alert('Account is closed, please contact admin.');
        }
        if(response.data.success){
          this.user = response.data.data
          localStorage.setItem('first_login', response.data.data.first_login)
          localStorage.setItem('user_id', response.data.data.id)
          localStorage.setItem('unique_id', response.data.data.unique_id)
          localStorage.setItem('iso_id', response.data.data.iso_id)
          localStorage.setItem('name', response.data.data.name)
          localStorage.setItem('access_token', response_auth.data.access_token)
          localStorage.setItem('email', this.login.email)
          this.autoLogOutFunction()
          this.$router.push('/dashboard');
        }else{
          localStorage.removeItem('access_token')
          this.processBar = true
          this.errors.push('The user credentials were incorrect');
        }
      });
      app.processBar = false
      // access_token = response_auth.data.access_token
      // localStorage.setItem('access_token', response_auth.data.access_token)
       
    },
  },

};
</script>
<style>
/* ADDS BLUR EFFECT TO BACKGROUND IMAGE */
.v-image__image {
  filter: brightness(90%) blur(2px);
}

#login .v-messages__message {
    color: red;
}

#login .error--text {
    color: #ff5252 !important;
    caret-color: #ff5252 !important;
}
</style>